import { Controller } from 'react-hook-form'

const patternRule = {
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: "Veuillez entrer une adresse email valide."
    }
  }

export default ({
  name = 'email',
  control,
  label = "Email",
  defaultValue = '',
  disabled = false,
  rules,
  validator = {},
  className = '',
}) => {
  const mergedRules = rules ? { ...patternRule, ...rules } : patternRule

  return (
  <Controller
    name={name}
    control={control}
    rules={mergedRules}
    defaultValue={defaultValue}
    render={({ field }) => (
      <div className={`${className}`}>
        <label className={`input w-full mb-4 ${validator.hasError ? 'validator' : ''}`}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <span className="label">{label}</span>
          <input
            type="email"
            {...field}
            value={field.value || ''}
            disabled={disabled}
          />
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </div>
    )}
  />
  )
}